import { Route, Routes } from "react-router-dom";
import Login from "./Pages/Auth/Login";
import DashboardLayout from "./Pages/Dashboard/DashboardLayout";
import AllCenters from "./Pages/Dashboard/Layouts/Centers/AllCenters";
import Index from "./Pages/Dashboard/Layouts/Index";
import "react-toastify/dist/ReactToastify.css";
import StudentProfile from "./Pages/Dashboard/Layouts/StudentProfile";

function App() {
  return (
    <Routes>
      <Route index element={<Login />} />
      <Route path="/centers/dashboard" element={<DashboardLayout />}>
        <Route index element={<Index />} />
        {/* <Route path="centers/all-centers" element={<AllCenters />} /> */}
        <Route path="student/:id" element={<StudentProfile />} />
      </Route>
      <Route path="*" element={<h2>Page not found</h2>} />
    </Routes>
  );
}

export default App;
